<template>
  <div>
    <b-alert show variant="danger" v-if="!order.complete">This order was partially picked before, check history before you
      proceed</b-alert>
    <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
    <b-alert show variant="danger" v-if="order.item_missing_from_stock">
      Following Models are missing from Stock, please add them then try the
      picking again.
      <ul>
        <li :key="index" v-for="(model, index) in order.models_missing_from_stock">
          <b>{{ model.model }}</b>
        </li>
      </ul>
    </b-alert>
    <div v-if="!order.item_missing_from_stock">
      <button class="btn btn-secondary ml-2 float-right" @click="showHistory">
        View History
      </button>
      <button to="home" class="btn btn-warning float-right" @click="printPickingNote">
        Picking Note
      </button>
      <button to="home" class="btn btn-info float-right mr-2" @click="printInvoice">
        Invoice
      </button>
      <span class="item_badge_to_pick" v-if="modelToPick != ''">
        <a class="pick_by_click" @click="pickByClick(modelToPick)">
          <span>{{ modelToPick }}</span>
        </a>
      </span>
      <img v-if="order.payment_code === 'blockchain'" class="float-right mr-3" src="/assets/icons/blockchain.png" />

      <span v-if="order.geo_zone_code === 'INT' || order.geo_zone_code === 'ZONE3' || order.shipping_country_id == 222 || order.geo_zone_id == '5' || order.geo_zone_id == '6' || order.geo_zone_id == '8'">
        <B>CUSTOMS</B>
      </span>

    </div>
    <div v-if="!order.item_missing_from_stock" class="scan-model-block">
      <form @submit.prevent="scanItem(scanModel)">
        <div class="form-group form-group-lg">
          <label for="model">Scan item model here</label>
          <input ref="model" type="text" class="form-control text-uppercase" id="model" placeholder="item model"
            name="model" v-model="scanModel" />
        </div>
        <button type="submit" class="btn btn-light" style="display:none;"></button>
      </form>

      <b-alert show variant="info" v-if="!scannedItems.length">No items scanned yet, please scan the first item.</b-alert>

      <span class="danger" style="width:30px;height: 10px;margin-right:10px;display: inline-block;"></span>Out of Order
      <span class="purple" style="width:30px;height: 10px;margin-right:10px;display: inline-block;"></span>
      Expiry less than 6 month
      <div class="card mb-3 mt-3" v-if="scannedItems.length">
        <div class="card-header text-white bg-secondary">Picked Items</div>
        <table class="table table-stripped" v-if="scannedItems.length">
          <thead>
            <tr>
              <th>Product</th>
              <th>Model</th>
              <th>Weight</th>
              <th>Expiry</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(item, index) in scannedItems" :class="{
              'danger text-white': item.outOfOrder,
              'purple text-white': item.monthsLeftTillExpiry <= 6
            }">
              <td>{{ item.name }}</td>
              <td>{{ item.model }}</td>
              <td>{{ (item.weight != '') ? item.weight + 'g' : '' }}</td>
              <td>
                <span v-if="item.expiry">
                  {{ item.expiry.month + "/" + item.expiry.year }}
                </span>
                <span v-else>NA</span>
              </td>
              <td>
                <button class="btn btn-danger btn-xs" @click="deleteItem(index)">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button class="btn btn-success float-right btn-lg ml-2" v-if="scannedItems.length" type="button"
        @click="submitPickingNote('next')">
        Submit (Go to next)
      </button>
      <button class="btn btn-success float-right btn-lg" v-if="scannedItems.length" type="button"
        @click="submitPickingNote('main')">
        Submit (Go to main)
      </button>
    </div>

    <button class="btn btn-warning float-right ml-2" v-if="!scannedItems.length && BRAND == 'IM'" type="button"
      @click="skip('w')">
      Skip(1week delay)
    </button>
    <button class="btn btn-danger float-right ml-2" v-if="!scannedItems.length && BRAND == 'IM'" type="button"
      @click="skip('d')">
      Skip(1day delay)
    </button>
    <button class="btn btn-info float-right" v-if="!scannedItems.length && BRAND == 'IM'" type="button"
      @click="outOfStock()">
      Out of stock
    </button>
    <nostock-modal ref="noStockModal" :items="itemsForOutOfStockDays"
      @outOfStockModalSubmit="outOfStockProceed"></nostock-modal>
    <pickingwarning-modal ref="pickingWarningModal"></pickingwarning-modal>
    <tracking-modal ref="trackingModal" :tracked="tracked"></tracking-modal>
    <partial-order-modal ref="partialOrderModal" :history="order.history"></partial-order-modal>
    <ups-modal ref="upsModalPopup" :upsResponse="upsResponse" :order="order"></ups-modal>
    <order-history-modal ref="orderHistoryModal" :history="order.history"></order-history-modal>
  </div>
</template>

<script>
import NostockModal from "@/components/picking/NostockModal.vue";
import PickingwarningModal from "@/components/picking/PickingwarningModal.vue";
import PartialOrderModal from "@/components/picking/PartialOrderModal.vue";
import OrderHistoryModal from "@/components/picking/OrderHistoryModal.vue";
import TrackingModal from "@/components/picking/TrackingModal.vue";
import UpsModal from "@/components/picking/UpsModal.vue";
import endOfMonth from "date-fns/endOfMonth";
import differenceInMonths from "date-fns/differenceInMonths";

export default {
  name: "opencart-picking-utility",
  props: ["order", "orderId"],
  components: {
    NostockModal,
    PickingwarningModal,
    TrackingModal,
    UpsModal,
    PartialOrderModal,
    OrderHistoryModal
  },
  data() {
    return {
      error: null,
      modelToPick: "",
      scannedItems: [],
      scannedItem: "",
      scanModel: "",
      skippedUntill: null,
      itemsForOutOfStockDays: [],
      submitAction: null,
      tracked: false,
      upsResponse: false,
      missingItems: [],
      orderComplete: true,
      partialOrderComment: "",
      scanItemWeightTotal: 0.00,
      scanEnvelopeWeightTotal: 0.00,
      envelopeRange: []

    };
  },
  mounted() {
    this.getNextItemToPick();
    this.getEnvelopes();
    this.orderId = this.$route.params.id;
  },
  methods: {
    printInvoice() {
      let url =
        this.APIURL + this.BRAND + "/order/invoice/" + this.order.order_id;
      window.open(url, "_blank");
    },
    printPickingNote() {
      let url =
        this.APIURL + this.BRAND + "/order/picking-note/" + this.order.order_id;
      window.open(url, "_blank");
    },
    pickByClick(modelToPick) {
      this.scanItem(modelToPick);
    },
    checkModelForExpiryDate(model) {
      var matches = model.match(/-[0-9]{6}/);
      if (matches) {
        var date = matches[0].split("-")[1];
        var year = date.substring(0, 4);
        var month = date.substring(4, 6);
        var formattedDate = new Date(year, month - 1);
        // var expiryEnd = endOfMonth(formattedDate);
        var currentMonth = new Date();
        var monthsLeftTillExpiry = differenceInMonths(
          endOfMonth(formattedDate),
          endOfMonth(currentMonth)
        );
        return {
          model: model.split(matches[0])[0],
          expiry: { year: year, month: month },
          monthsLeftTillExpiry: monthsLeftTillExpiry
        };
      } else {
        return { model: model, expiry: false };
      }
    },
    scanItem(model) {
      var res = this.checkModelForExpiryDate(model);
      this.scannedItem = res.model;
      this.error = "";
      let loader = this.$loading.show();
      let partofOrder = false;
      //check if this item is part of the orde items
      this.order.items.forEach(item => {
        if (
          item.model.toUpperCase().trim() ==
          this.scannedItem.toUpperCase().trim()
        ) {
          //then check if the item already in the scanned items then inc quantity else add it
          item.scanCount++;
          item.outOfOrder = false;
          this.scannedItems.push({
            ...item,
            expiry: res.expiry,
            monthsLeftTillExpiry: res.monthsLeftTillExpiry
          });
          partofOrder = true;
        }
      });

      if (!partofOrder) {
        this.notPartofOrder(loader);
      }

      this.calculateItemWeight();
      this.scannedItem = "";
      this.scanModel = "";
      loader.hide();
      this.getNextItemToPick();
    },
    notPartofOrder(loader) {
      let itemModel = this.scannedItem.toUpperCase().trim();
      let outOfOrderItemQty = 1;

      if ( this.scannedItems.filter(({ model }) => model === itemModel).length > 0 ) {
        return;
      }

      let envelop = this.envelopeRange.filter((item) => item.model === itemModel);
      if (envelop.length > 0) {
        envelop = envelop[0];
        this.scannedItems.push({
          'model':envelop.model,
          'outOfOrder': false,
          'name': envelop.name,
          'monthsLeftTillExpiry':undefined,
          'weight': envelop.weight
        });
      } else {

        //was this item scanned before ?
        this.scannedItems.forEach(item => {
          //if yes then quantity needed = previous scanned quantity + 1
          if (item.model.toUpperCase().trim() == itemModel.toUpperCase().trim()) {
            outOfOrderItemQty++;
          }
        });

        //does this item with the needed quantity exist in the DB ?
        this.$http
          .get(
            this.APIURL +
            this.BRAND +
            "/stock-exist?model=" +
            itemModel +
            "&qty=" +
            outOfOrderItemQty
          )
          .then(
            response => {
              let data = response.data;
              if (data.status == "success") {
                //if yes then add the item to scanned items in red and set a flag that items out of order scanned = yes
                data.item.outOfOrder = true;
                this.scannedItems.push(data.item);
                this.scannedItem = "";
              } else if (data.status == "not-found") {
                //if no then display a modal popup with error and just a dismiss button
                this.error =
                  "The scanned item either doesn't exist or the stocked quantity is not enough.";
              }
              loader.hide();
              this.$refs.model.focus();
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    getNextItemToPick() {
      //loop though order items array and check when scanned quantity is not equal
      //the required quantity then return this item model number
      let modelsToPick = [];
      if (this.order.items.length) {
        this.order.items.forEach(item => {
          if (item.scanCount < item.quantity) {
            modelsToPick.push(item.model);
          }
        });
        if (modelsToPick.length) {
          this.modelToPick = modelsToPick[0];
        } else {
          this.modelToPick = "";
        }
      } else {
        this.modelToPick = "";
      }
    },
    calculateItemWeight() {
      this.scanItemWeightTotal = 0.00;
      this.scannedItems.forEach(item => {
        this.scanItemWeightTotal += parseInt(item.weight);

        let envelop = this.envelopeRange.filter((i) => i.model === item.model);
        if (envelop && envelop.length > 0) {
          this.scanEnvelopeWeightTotal = parseInt(item.weight);
        }
      });
    },
    deleteItem(index) {
      this.error = "";
      //get item model
      let model = this.scannedItems[index].model.toUpperCase().trim();
      //search for this item in the order items and descrease the scane count
      this.order.items.forEach(item => {
        if (item.model.toUpperCase().trim() == model) {
          item.scanCount--;
        }
      });

      //remove the item from scanned array
      this.scannedItems.splice(index, 1);
      this.getNextItemToPick();
      setTimeout(() => this.calculateItemWeight(), 500);
      this.$refs.model.focus();
    },
    skip(type) {
      let loader = this.$loading.show();
      if (type == "d") {
        //then skip for a day
        this.skippedUntill = this.$moment()
          .add(1, "d")
          .unix();
      } else if (type == "w") {
        //then skip for an hour
        this.skippedUntill = this.$moment()
          .add(7, "d")
          .unix();
      }

      this.$http
        .post(this.APIURL + this.BRAND + "/delay-order", {
          orderID: this.orderId,
          skippedUntill: this.skippedUntill
        })
        .then(
          response => {
            if (response.data.status == "success") {
              window.location.href =
                "/order/" + response.data.order_id + "/pick";
            } else {
              loader.hide();
              this.$router.push({ path: "/orders" });
            }
          },
          error => {
            console.log(error);
          }
        );
    },
    outOfStock() {
      this.itemsForOutOfStockDays = this.order.items.concat(
        this.order.models_missing_from_stock
      );
      this.itemsForOutOfStockDays.forEach(function (item) {
        item.days = 28;
      });
      //show modal with items and drop downs for each in the shape of form
      this.$refs.noStockModal.showModal();
    },
    outOfStockProceed(items) {
      let loader = this.$loading.show();

      //send items to API to send the email to customer, mark order hsitory and mark order status as out of stock
      this.$http
        .post(this.APIURL + this.BRAND + "/trigger-out-of-stock", {
          order_id: this.orderId,
          items: items
        })
        .then(
          () => {
            loader.hide();
            this.$router.push({ path: "/orders" });
          },
          error => {
            console.log(error);
          }
        );
    },
    submitPickingNote(target) {
      //set submit action variable in the view file to requested action
      this.submitAction = target;

      this.error = "";
      var outOfOrder = false;
      var qtyMatch = true;

      //check if all order items are matching the scanned items
      this.order.items.forEach(item => {
        if (item.scanCount != item.quantity) {
          qtyMatch = false;
        }
      });

      this.scannedItems.forEach(item => {
        if (item.outOfOrder) {
          outOfOrder = true;
        }
      });

      if (!qtyMatch) {
        // this.error = 'Order quantities and scanned ones do not match!';
        // this.handlePickingNote(qtyMatch);
        this.$refs.partialOrderModal.showModal();
        //display modal asking for partial order confirmation
      } else if (outOfOrder) {
        //then display a modal window with a warning
        this.$refs.pickingWarningModal.showModal();
      } else {
        this.handlePickingNote();
      }
    },
    handlePickingNote() {
      /*=========================================
      =            IM handle picking            =
      =========================================*/
      if (this.BRAND == "IM") {
        if (String(this.order.shipping_method).includes("UPS")) {
          //send request to generate ups label
          this.requestUpsLabel(this.orderId);
        } else {
          if (String(this.order.shipping_method).includes("Tracked")) {
            this.tracked = true;
          }
          this.$refs.trackingModal.weight = this.scanItemWeightTotal;
          this.$refs.trackingModal.envelopeWeight = this.scanEnvelopeWeightTotal;
          this.$refs.trackingModal.showModal();
        }

        /*=========================================
      =            SM handle picking            =
      =========================================*/
      } else if (this.BRAND == "SM") {
        if (
          String(this.order.shipping_method).includes("Express") ||
          String(this.order.shipping_method).includes("tracked")
        ) {
          this.tracked = true;
          this.$refs.trackingModal.showModal();
        } else {
          this.shipOrder({ weight: 0 });
        }
      } else if (this.BRAND == "EB") {
        if (
          String(this.order.shipping_method).includes(
            "UK_RoyalMailInternationalSignedFor"
          )
        ) {
          this.tracked = true;
          this.$refs.trackingModal.showModal();
        } else {
          this.shipOrder({ weight: 0 });
        }
      }
    },
    requestUpsLabel(orderId) {
      let loader = this.$loading.show();

      this.$http
        .post(this.APIURL + this.BRAND + "/ups/confirm", {
          "order-id": orderId
        })
        .then(
          response => {
            this.upsResponse = response.data;
            //if response fails then show modal
            if (this.upsResponse.status == "0") {
              this.$refs.upsModalPopup.showModal();
              loader.hide();
            } else {
              this.acceptUpsLabel(
                this.upsResponse.ShipmentIdentificationNumber,
                loader
              );
            }
          },
          error => {
            console.log(error);
          }
        );
    },
    acceptUpsLabel(ShipmentIdentificationNumber, loader) {
      //send request to accept shipment
      this.$http
        .post(this.APIURL + this.BRAND + "/ups/accept", {
          "shipment-id": ShipmentIdentificationNumber
        })
        .then(
          response => {
            this.upsResponse = response.data;
            //if response fails then show modal
            if (this.upsResponse.status == "0") {
              this.$refs.upsModalPopup.showModal();
              loader.hide();
            } else {
              loader.hide();
              //open a new page to display the label and trigger print
              this.printUpsLabel();
              //then shiporder
              this.shipOrder({ weight: 0 });
            }
          },
          error => {
            loader.hide();
            console.log(error);
          }
        );
    },
    printUpsLabel() {
      var url = this.APIURL + this.BRAND + "/ups/label/" + this.order.order_id;
      window.open(url, "_blank");
    },
    shipOrder(event) {
      //hide all modal windows
      if (typeof this.$refs.upsModalPopup != "undefined") {
        this.$refs.upsModalPopup.hideModal();
      }
      if (typeof this.$refs.upsModalPopup != "undefined") {
        this.$refs.trackingModal.hideModal();
      }
      //show loader
      let loader = this.$loading.show();

      let httpData = {
        scanned_items: this.scannedItems,
        order_id: this.orderId,
        tracking_number: event.trackingNumber,
        weight: event.weight,
        envelope_weight: this.scanEnvelopeWeightTotal,
        missing_items: this.missingItems,
        order_complete: this.orderComplete,
        partial_order_comment: this.partialOrderComment,
        shipping_method: this.order.shipping_method
      };

      this.$http.post(this.APIURL + this.BRAND + "/order-ship", httpData).then(
        response => {
          if (
            response.data.status == "success" &&
            this.submitAction == "next"
          ) {
            //on success navigate to that order to start picking
            window.location.href = "/order/" + response.data.order_id + "/pick";
          } else if (response.data.status == 'no_envelope') {
            loader.hide();
            this.error = response.data.error;
          } else {
            this.$router.push({ path: "/orders" });
            loader.hide();
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    handlePartialOrder($event) {
      let missingItems = [];
      this.order.items.forEach(item => {
        if (item.scanCount != item.quantity) {
          //missing qty
          item.missingQty = item.quantity - item.scanCount;
          missingItems.push(item);
        }
      });
      this.missingItems = missingItems;
      this.orderComplete = $event.complete;
      this.partialOrderComment = $event.comment;
      this.handlePickingNote();
    },
    showHistory() {
      this.$refs.orderHistoryModal.showModal();
    },
    getEnvelopes: function () {
      let loader = this.$loading.show();
      this.envelopeRange = [];
      this.$http.get(this.APIURL + this.BRAND + "/envelopes").then(
        response => {
          response.data.envelopes.map((value) => {
            this.envelopeRange.push({
              "model": value.model,
              'name': value.name,
              'weight': value.weight
            })
          })
          loader.hide();
        },
        error => {
          loader.hide();
          // console.log(error);
        }
      );
    },
  }
};
</script>
